import "./Timeline.css";
import "./CustomTimeline";

import { useTranslation } from "react-i18next";

import { DataLoader } from "../DataLoader";
import { LiveCommentary } from "../LiveCommentary";
import React from "react";

interface TimelineProps {
  programDetails: { programId: string; isLoading: boolean };
}

export default function Timeline({ programDetails }: TimelineProps) {
  const { programId, isLoading } = programDetails;
  const { i18n, t } = useTranslation();

  if (isLoading) {
    return (
      <DataLoader
        customStyle={{
          height: "90dvh",
        }}
      />
    );
  }

  if (!programId) {
    return <p className="timeline-error">{t("timeline.missingProgramId")}</p>;
  }

  return (
    <div className="timeline-container">
      <LiveCommentary />
      <sbs-timeline
        programId={programId}
        language={i18n.resolvedLanguage}
      ></sbs-timeline>
    </div>
  );
}
